<!-- eslint-disable consistent-return -->
/* eslint-disable max-len */
<template>
  <div>
    <div class="ui-grid" style="height: 200px" v-if="!testResult">
      Fetching sociogram result, please wait...
    </div>
    <div class="ui grid" v-if="testResult">
      <div class="row">
        <h1 class="ui huge header">
          Sociometric Report for class {{ testResult.class.name }}
        </h1>
      </div>
      <div class="ui divider"></div>
      <div class="row">
        <sui-button primary content="How to Use Generate Report Function" icon="question circle"
          v-on:click="openGallery(6)" />
        <sui-button primary content="How to Use Generate Teams Button" icon="question circle"
          v-on:click="openGallery(7)" />
      </div>
      <div class="row">
        <test-class-culture v-bind:test-result="testResult" />
      </div>
      <div class="row">
        <p v-if="testResult.progress !== 100" class="ui negative message">
          The Nominations have not yet been completed by everyone in the class.
          Current progress: {{ testResult.progress }}%
        </p>
        <p v-else class="ui positive message">
          The Nominations have been completed by all students.
        </p>
      </div>
      <div class="row">
        <table class="ui striped selectable table">
          <thead>
            <tr>
              <th style="cursor: pointer" v-on:click="setOrderBy('lastName')">
                <span><u>Last name</u>
                  <i v-if="orderBy === 'lastName' && orderDirection === 'asc'" class="angle up icon" />
                  <i v-if="orderBy === 'lastName' && orderDirection === 'desc'" class="angle down icon" />
                </span>
              </th>
              <th style="cursor: pointer" v-on:click="setOrderBy('firstName')">
                <span><u>First name</u>
                  <i v-if="orderBy === 'firstName' && orderDirection === 'asc'" class="angle up icon" />
                  <i v-if="orderBy === 'firstName' && orderDirection === 'desc'" class="angle down icon" />
                </span>
              </th>
              <th>
                <span><u>Initials</u>
                </span>
              </th>
              <th style="cursor: pointer" v-on:click="setOrderBy('socialImpact')">
                <span><u>Social impact</u>
                  <i v-if="
                    orderBy === 'socialImpact' && orderDirection === 'asc'
                  " class="angle up icon" />
                  <i v-if="
                    orderBy === 'socialImpact' && orderDirection === 'desc'
                  " class="angle down icon" />
                </span>
              </th>
              <th style="cursor: pointer" v-on:click="setOrderBy('socialPreference')">
                <span><u>Social preference</u>
                  <i v-if="
                    orderBy === 'socialPreference' && orderDirection === 'asc'
                  " class="angle up icon" />
                  <i v-if="
                    orderBy === 'socialPreference' &&
                    orderDirection === 'desc'
                  " class="angle down icon" />
                </span>
              </th>
              <th>
                Classification(s)
                <sui-button icon="question circle" v-on:click="showClassificationLegend($event, null)" />
              </th>
              <th style="cursor: pointer" v-on:click="setOrderBy('groupLabel')">
                <span><u>Team number</u>
                  <i v-if="orderBy === 'groupLabel' && orderDirection === 'asc'" class="angle up icon" />
                  <i v-if="orderBy === 'groupLabel' && orderDirection === 'desc'" class="angle down icon" />
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="students.length == 0">
              <td></td>
              <td colspan="4">No students found</td>
            </tr>
            <tr v-else v-for="result in students" style="cursor: pointer" v-bind:key="result.student.id"
              v-on:click="showDetailsModal(result)" title="Click to see the result details the student">
              <td>{{ result.student.lastName }}</td>
              <td>{{ result.student.firstName }}</td>
              <td>{{ result.student.initials }}</td>
              <td>{{ result.socialImpact }}</td>
              <td>{{ result.socialPreference }}</td>
              <td>
                <span v-for="classification in result.classifications" v-bind:key="classification">
                  <a v-if="classification == 'Liked'" v-on:click="showClassificationLegend($event, 'L')"
                    class="ui purple label">L
                  </a>
                  <a v-if="classification == 'OneLikeReceived'" v-on:click="showClassificationLegend($event, '1LR')"
                    class="ui grey label">1LR
                  </a>
                  <a v-if="classification == 'Unchosen'" v-on:click="showClassificationLegend($event, 'UN')"
                    class="ui grey label">UN
                  </a>
                  <a v-if="classification == 'Rejected'" v-on:click="showClassificationLegend($event, 'R')"
                    class="ui yellow label">R
                  </a>
                  <a v-if="classification == 'Neglected'" v-on:click="showClassificationLegend($event, 'N')"
                    class="ui green label">N
                  </a>
                  <a v-if="classification == 'Controversial'" v-on:click="showClassificationLegend($event, 'C')"
                    class="ui teal label">C
                  </a>
                  <a v-if="classification == 'Average'" v-on:click="showClassificationLegend($event, 'A')"
                    class="ui brown label">A
                  </a>
                  <a v-if="classification == 'Unclassified'" v-on:click="showClassificationLegend($event, 'UC')"
                    class="ui blue label">UC
                  </a>
                </span>
              </td>
              <td>{{ result.groupLabel }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="row">
        <div>
          <sui-dropdown placeholder="Select the team size" selection name="group-size" :options="groupSizes"
            v-model="group.size" />
          <sui-button content="Update team size" positive icon="users" v-on:click="formGroups" />
          <sui-button content="Generate report" primary icon="users" v-on:click="generateReport" />
          <sui-button content="Generate team list" secondary icon="users" v-on:click="generateTeamListReport" />
        </div>
      </div>
      <div v-if="isTrueAdmin" class="ui divider"></div>
      <div v-if="isTrueAdmin" class="row">
        <div class="ui segment" style="width: 100%;">
          <h3>Share this report with a guest</h3>
          <p>Enter an email address to create a guest account and share this report.</p>
          <div class="ui form">
            <div class="field">
              <label>Guest Email</label>
              <div class="ui action input">
                <input type="email" v-model="guestEmail" placeholder="Enter email address" required />
                <sui-button content="Share" primary icon="share" v-on:click="shareWithGuest"
                  :disabled="!isValidEmail" />
              </div>
            </div>
            <div v-if="shareError" class="ui negative message">
              {{ shareError }}
            </div>
            <div v-if="shareSuccess" class="ui positive message">
              <h4>Guest account created successfully!</h4>
              <p>Copy and paste this URL to share in your email:</p>
              <div class="ui fluid input">
                <input type="text" v-model="currentUrl" readonly ref="urlInput" />
              </div>
              <sui-button content="Copy URL" secondary icon="copy" v-on:click="copyUrl" style="margin-top: 10px;" />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <router-link to="/test/select">
          <sui-button content="Back to Reports page" positive icon="circle arrow left" />
        </router-link>
      </div>
      <div class="row" style="min-height: 500px"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TestClassCulture from '@/components/tests/TestClassCulture';
import testsApi from '@/api/tests';

export default {
  name: 'TestResult',
  components: { TestClassCulture },
  computed: {
    ...mapGetters({
      user: 'user',
    }),
    isAdmin: {
      get() {
        return this.user && this.user.profile &&
          (this.user.profile.role === 'Administrator' || this.user.profile.role === 'TeacherAdministrator');
      },
    },
    isTrueAdmin: {
      get() {
        return this.user && this.user.profile &&
          (this.user.profile.role === 'Administrator');
      },
    },
    isValidEmail() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(this.guestEmail);
    },
    students() {
      const sortedStudents = this.testResult.students;
      switch (this.orderBy) {
        case 'lastName':
          sortedStudents.sort((a, b) => {
            if (a.student.lastName < b.student.lastName) {
              return this.orderDirection === 'asc' ? -1 : 1;
            }
            if (a.student.lastName > b.student.lastName) {
              return this.orderDirection === 'asc' ? 1 : -1;
            }
            return 1;
          });
          break;
        case 'firstName':
          sortedStudents.sort((a, b) => {
            if (a.student.firstName < b.student.firstName) {
              return this.orderDirection === 'asc' ? -1 : 1;
            }
            if (a.student.firstName > b.student.firstName) {
              return this.orderDirection === 'asc' ? 1 : -1;
            }
            return 1;
          });
          break;
        case 'dateOfBirth':
          sortedStudents.sort((a, b) => {
            if (a.student.dateOfBirth < b.student.dateOfBirth) {
              return this.orderDirection === 'asc' ? -1 : 1;
            }
            if (a.student.dateOfBirth > b.student.dateOfBirth) {
              return this.orderDirection === 'asc' ? 1 : -1;
            }
            return 1;
          });
          break;
        case 'socialImpact':
          sortedStudents.sort((a, b) => {
            if (a.socialImpact < b.socialImpact) {
              return this.orderDirection === 'asc' ? -1 : 1;
            }
            if (a.socialImpact > b.socialImpact) {
              return this.orderDirection === 'asc' ? 1 : -1;
            }
            return 1;
          });
          break;
        case 'socialPreference':
          sortedStudents.sort((a, b) => {
            if (a.socialPreference < b.socialPreference) {
              return this.orderDirection === 'asc' ? -1 : 1;
            }
            if (a.socialPreference > b.socialPreference) {
              return this.orderDirection === 'asc' ? 1 : -1;
            }
            return 1;
          });
          break;
        case 'groupLabel':
          sortedStudents.sort((a, b) => {
            if (a.group < b.group) {
              return this.orderDirection === 'asc' ? -1 : 1;
            }
            if (a.group > b.group) {
              return this.orderDirection === 'asc' ? 1 : -1;
            }
            return 1;
          });
          break;
        default:
          break;
      }
      return sortedStudents;
    },
  },
  data() {
    return {
      testResult: null,
      orderBy: 'lastName',
      orderDirection: 'asc',
      result: null,
      group: { size: 3 },
      groupSizes: [
        { text: '2', value: 2 },
        { text: '3', value: 3 },
        { text: '4', value: 4 },
      ],
      guestEmail: '',
      shareError: null,
      shareSuccess: false,
      currentUrl: '',
    };
  },
  created() {
    this.$store
      .dispatch('getTestResult', {
        id: this.$route.params.id,
        size: this.group.size,
      })
      .then((response) => {
        this.testResult = response.data;
      });
  },
  methods: {
    openGallery(index) {
      this.$store.dispatch('showImage', { index });
    },
    showClassificationLegend(event, category) {
      event.stopPropagation();
      this.$store.dispatch('showClassificationLegend', category);
    },
    hideClassificationLegend() {
      this.$store.dispatch('hideClassificationLegend');
    },
    showDetailsModal(result) {
      const testResultCopy = JSON.parse(JSON.stringify(this.testResult));
      testResultCopy.students.forEach((student) => {
        student.choices = student.choices.filter(
          // eslint-disable-next-line arrow-parens
          (choice) => choice.targetStudent.id === result.student.id,
        );
      });
      this.$store.dispatch('setTestResult', testResultCopy);

      this.$store.dispatch('setTestResultDetails', result);
      this.$store.dispatch('showTestResultDetailsNew');
    },
    hideDetailsModal() {
      this.$store.dispatch('hideTestResultDetailsNew');
    },
    formGroups() {
      this.$store
        .dispatch('getTestResult', {
          id: this.$route.params.id,
          size: this.group.size,
        })
        .then((response) => {
          this.testResult = response.data;
        });
    },
    generateReport() {
      this.$store.dispatch('showLoader');
      testsApi
        .generateReport(this.$route.params.id)
        .then((response) => {
          const blob = new Blob([response.data], { type: response.data.type });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          const contentDisposition = response.headers['content-disposition'];
          let fileName = 'unknown';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+);/);
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1].replaceAll('"', '');
            }
          }
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .finally(() => {
          this.$store.dispatch('hideLoader');
        });
    },
    generateTeamListReport() {
      this.$store.dispatch('showLoader');
      testsApi
        .generateTeamListReport(this.$route.params.id, this.group.size)
        .then((response) => {
          const blob = new Blob([response.data], { type: response.data.type });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          const contentDisposition = response.headers['content-disposition'];
          let fileName = 'unknown';
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename=(.+);/);
            if (fileNameMatch.length === 2) {
              fileName = fileNameMatch[1].replaceAll('"', '');
            }
          }
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .finally(() => {
          this.$store.dispatch('hideLoader');
        });
    },
    setOrderBy(column) {
      if (this.orderBy === column) {
        this.orderDirection = this.orderDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.orderBy = column;
        this.orderDirection = 'asc';
      }
    },
    shareWithGuest() {
      if (!this.guestEmail) {
        this.shareError = 'Please enter an email address';
        return;
      }
      if (!this.isValidEmail) {
        this.shareError = 'Please enter a valid email address';
        return;
      }
      this.shareError = null;
      this.shareSuccess = false;

      const guest = {
        email: this.guestEmail,
        testIds: [this.$route.params.id],
      };

      this.$store.dispatch('newGuest', guest).then(
        () => {
          this.shareSuccess = true;
          this.currentUrl = window.location.href.replace(
            '/result',
            '/share',
          );
          this.guestEmail = '';
        },
        (error) => {
          if (error.response && error.response.data && error.response.data.message) {
            this.shareError = error.response.data.message || 'Failed to create guest account. Please try again.';
          }
        },
      );
    },
    copyUrl() {
      this.$refs.urlInput.select();
      document.execCommand('copy');
      this.$dialog.alert('URL copied to clipboard!');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tests/TestResult.vue